import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { useCurrentDoseView } from '~/hooks/dose/useCurrentDose';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';
import { buildTargetDoseLookup } from '~/utils/transforms/doseTargetsTransforms';
import type { RoiId } from '~/domain/changes/ids';

/**
 * Map of structure (current) name → prescribed dose (Gy) for the
 * targets of the loaded dose. Empty when no dose / no targets.
 */
const useDoseTargetLookup = (): Map<string, number> => {
    const doseData = useCurrentDoseView();
    const structureSet = useRecoilValue(currentStructureSetState);

    return useMemo(() => {
        const nameByRoiId = new Map<RoiId, string>();
        for (const roi of structureSet?.roiArray ?? []) {
            nameByRoiId.set(roi.roiId, roi.name);
        }
        return buildTargetDoseLookup(doseData?.targets, (roiId) =>
            nameByRoiId.get(roiId)
        );
    }, [doseData?.targets, structureSet]);
};

export default useDoseTargetLookup;
